// src/pages/Earnings.js
import React, { useState, useEffect } from "react";
import { ref, onValue, orderByChild, equalTo, query } from "firebase/database";
import { Link, useNavigate } from "react-router-dom";
import { auth, db } from "../utilities/firebaseConfig";
import TechnicianDashboardLayout from "../components/TechnicianDashboardLayout";
import Loader from "../components/Loader";

const TechnicianWallet = () => {
  const [wallet, setWallet] = useState({ balance: 0, transactions: {} });
  const [jobs, setJobs] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  let navigate = useNavigate();

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setError("User not authenticated");
      navigate("/technician/dashboard");
      setLoading(false);
      return;
    }

    const walletRef = ref(db, `wallets/${user.uid}`);
    const jobsRef = ref(db, "jobs");

    // Query to get jobs for this technician
    const technicianJobsQuery = query(
      jobsRef,
      orderByChild("technicianId"),
      equalTo(user.uid)
    );

    const unsubscribeWallet = onValue(
      walletRef,
      (snapshot) => {
        const walletData = snapshot.val();
        setWallet(walletData || { balance: 0, transactions: {} });
      },
      (error) => {
        console.error("Error fetching wallet:", error);
        setError("Failed to load wallet data");
        setLoading(false);
      }
    );

    const unsubscribeJobs = onValue(
      technicianJobsQuery,
      (snapshot) => {
        const jobsData = snapshot.val();
        setJobs(jobsData || {});
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching jobs:", error);
        setError("Failed to load job data");
        setLoading(false);
      }
    );

    return () => {
      unsubscribeWallet();
      unsubscribeJobs();
    };
  }, []); // Empty dependency array to run only once on mount

  if (loading) return <Loader />;
  if (error) return <div className='error'>{error}</div>;

  // Combine wallet transactions with job details
  const enrichedTransactions = Object.entries(wallet.transactions || {}).map(
    ([jobId, transaction]) => {
      const jobDetails = jobs[jobId] || {};
      return {
        ...transaction,
        jobDetails: {
          title: jobDetails.jobtitle,
          description: jobDetails.jobdescription,
          date: jobDetails.date,
          address: jobDetails.address,
          status: jobDetails.status,
          amount: jobDetails.totalamount,
          clientName: jobDetails.userName,
          clientPhone: jobDetails.userPhone,
        },
      };
    }
  );

  return (
    <>
      <TechnicianDashboardLayout>
        <div className='theclientdsh'>
          <div className='theclientdshtop'>
            <h1 className='theclidashbtntit'>Earning</h1>
          </div>
          <div className='thespac'></div>
          <div className='aklhsla'>
            <div className='kjaklhhjs'>
              <p className='aokhsl'>Available earnings</p>
              <div className='thespace'></div>
              <p className='alkshs'>
                ₦{wallet?.balance?.toLocaleString() || "0"}
              </p>
              <div className='thespacee'></div>
              <button className='ajklash'>Withdraw earning</button>
            </div>
            <div className='jaslash'>
              <div className='kjaklhhjs'>
                <p className='aokhsl'>Total Earnings</p>
                <div className='thespace'></div>
                <p className='alkshs'>
                  ₦{wallet?.balance?.toLocaleString() || "0"}
                </p>
                <div className='thespacee'></div>
                <button className='ajklash'>View weekly payment</button>
              </div>
              <div className='kjaklhhjs'>
                <p className='aokhsl'>Earning Payout</p>
                <div className='thespace'></div>
                <p className='alkshs'>
                  ₦{wallet?.balance?.toLocaleString() || "0"}
                </p>
                <div className='thespacee'></div>
                <button className='ajklash'>Transaction history</button>
              </div>
            </div>
          </div>
          <div className='thespacee'></div>
          <div className='thespacee'></div>
          <div className='transaction-section'>
            <h1 className='theclidashbtntit'>Recent Transaction</h1>
            <div className='thespace'></div>
            {enrichedTransactions.length > 0 ? (
              <div className='transactions-list'>
                {enrichedTransactions.map((tx, index) => (
                  <div key={index} className='transaction-item'>
                    <div className='lahskla'>
                      <p className='alksahs'>
                        Sent from {tx.jobDetails.clientName || "N/A"}
                      </p>
                      <p className='lasklhal'>
                        + ₦{tx.amount?.toLocaleString()}
                      </p>
                    </div>
                    <div className="thespace"></div>
                    <div className='ajsalja'>
                      <div className='jlaskja'>
                        <p className='alkjsasn'>
                          {tx.jobDetails.title || "Untitled Job"}
                        </p>
                        <p className='aklsakln'>
                          {new Date(tx.timestamp).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </p>
                      </div>
                      <p className='aklsalsn'>{tx.status}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className='no-transactions'>
                <p>No transactions found</p>
              </div>
            )}
          </div>
        </div>
      </TechnicianDashboardLayout>
    </>
  );
};

export default TechnicianWallet;
